import { Question } from './question.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class ReadingQuestion extends Question {
  public static fromDto(dto: any): ReadingQuestion {
    const question: ReadingQuestion = new ReadingQuestion();
    Question.mapBaseProperties(question, dto);
    return question;
  }
}
